var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "result-bar__sort" },
    [
      _c("select-field", {
        attrs: { options: _vm.sortOptions, "icon-type": "sort" },
        model: {
          value: _vm.selectedSortOption,
          callback: function($$v) {
            _vm.selectedSortOption = $$v
          },
          expression: "selectedSortOption"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-541facdc", { render: render, staticRenderFns: staticRenderFns })
  }
}